function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#0044F0"
        fillRule="evenodd"
        d="M8 6.609L14.609 0 16 1.391 9.391 8 16 14.609 14.609 16 8 9.391 1.391 16 0 14.609 6.609 8 0 1.391 1.391 0 8 6.609z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default Icon;
